<template>
  <div class="brand">
    <Fontnavbar title="品牌"/>
    <backTop/>
		<div class="brands">
			<div class="brand_title">热门品牌</div>
			<div class="brand_imgs">
        <div  class="b_i_i" v-for="(item,index) in goods" :key="index" @click="go(item.id)">
             <van-image
                  width="71"
                  height="40"
                  :src="imgDomain+item.brand_thumb_path"
                />

              
        </div>
		</div>
  <div class="center" v-for="(items,indexs) in brandlist" :key="indexs">
          <div class="center_title">{{items.brand_name}}</div>
        <div class="center_imgs">
          <div  class="c_i" v-for="(itemss,indexss) in brandlist[indexs].child_brand" :key="indexss" @click="go(itemss.id)">
              <!-- <van-image
                    width="71"
                    height="40"
                    :src="imgDomain+itemss.brand_thumb_path"
                  /> -->
                <div class="title">
                    {{itemss.brand_name}}
              </div>
          </div>
      </div>
			</div>

  </div>
   </div>
</template>

<script>
import {
	Tab, 
	Tabs,
  Sidebar, 
	SidebarItem,
  Dialog
} from 'vant';
import Fontnavbar from "../../../components/Navbar.vue";
import { brand } from '../../../api.js'
import { post } from '../../../request.js'
import backTop from "../../../components/backTop.vue";
import { Image} from "vant";
export default {
  components: {
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
    [Image.name]: Image,
    Fontnavbar,
    backTop
  },

  data() {
    return {
			activeKey: 0,
      goods: [],
      brandlist:[],
      imgDomain: process.env.VUE_APP_IMG_URL
    };
  },

  mounted(){
      const that = this
		// console
		post(brand, {}).then((res) => {
			if (res.code == 200) {
				that.brandlist = res.data.brands;
        that.goods=res.data.recommend;
			} else {
				Dialog({message:"网络错误"})
			}
		})
  },


  methods: {
		go(e){
       this.$router.push({
                        path:'/goods/index',
                       query:{
                          brand_id:e
         }
          })
    }
  }
};
</script>

<style lang="less" scoped>
.brand_title{
  margin-left: 3%;
  margin-right: 3%;
  padding-bottom: 5%;
  padding-top: 5%;
  border-bottom: 1px solid gray;
}

.brand_imgs{
  display: flex;
  margin-left: 5%;
 margin-right: 3%;
  flex-wrap: wrap;
}

.b_i_i{
  padding-top: 5%;
  padding-right: 3%;
}



.center_title{
   margin-left: 3%;
  margin-right: 3%;
  padding-bottom: 5%;
  padding-top: 5%;
  border-bottom: 1px solid gray;
}

.center_imgs{
    display: flex;
  margin-left: 5%;
 margin-right: 3%;
  flex-wrap: wrap;
}

.c_i{
   padding-top: 5%;
  padding-right: 3%;
}

.c_i .title{
  width: 100px;
  height: 40px;
  background-color: #fff;
  text-align: center;
  line-height: 40px;
  font-size: 12px;
  white-space: nowrap;
}
</style>
